export const pageIdSym = Symbol('pageId')
export const PageAssetsLoaderSymbol = Symbol('PageAssetsLoaderSymbol')
